export const CLIENT_PORTFOLIO_CLIENT_TYPE = Object.freeze({
  ALL: 'all',
  PREFERRED_FIXED_AGENT: 'PREFERRED_FIXED_AGENT',
  NON_PREFERRED_FIXED_AGENT: 'NON_PREFERRED_FIXED_AGENT',
});

export const CLIENT_PORTFOLIO_CLIENT_TYPE_VALUE = Object.freeze({
  true: CLIENT_PORTFOLIO_CLIENT_TYPE.PREFERRED_FIXED_AGENT,
  false: CLIENT_PORTFOLIO_CLIENT_TYPE.NON_PREFERRED_FIXED_AGENT,
});
